export class GrowGreenCalculator {
  constructor(growGreenCalculatorData) {
    this.dadosAPI = {};
    this.larguraModulo = 0.653;
    this.alturaModulo = 0.218;
    this.larguraNicho = 0.2177;
    this.larguraDuplo = 0.4353;

    this.alturaParede = growGreenCalculatorData.alturaParede;
    this.larguraParede = growGreenCalculatorData.larguraParede;
    this.temIrrigacao = growGreenCalculatorData.temIrrigacao;

    this.alturaJardimVertical = 0;
    this.larguraJardimVertical = 0;
    this.areaJardimVertical = 0;
    this.totalPlantas = 0;
    this.modulosDeAltura = 0;
    this.modulosDeLargura = 0;
    this.totalModulosInteiros = 0;
    this.totalModulosNicho = 0;
    this.totalModulosDuplos = 0;

    this.totalPlacaHorizontal = 0;
    this.totalPlacaVertical = 0;
    this.totalPlacaNicho = 0;
    this.totalPlacaDuplo = 0;
    this.totalVasosGrowGreen = 0;
    this.totalConchaGrowGreen = 0;
    this.totalTelaGrowGreen = 0;
    this.totalPinoDaConcha = 0;
    this.totalInicialFinal = 0;
    this.totalPinoDeTravamento = 0;

    this.totalTuboCego = 0;
    this.totalGotejador = 0;
    this.totalConectorTe = 0;
    this.totalFinalDeLinha = 0;
    this.totalConectorCotovelo = 0;
    this.totalConectorInicial = 0;

    this.totalParafusos = 0;
    this.totalBuchas = 0;

    this.calculaDimensoes(growGreenCalculatorData);
    this.calculaQuantidades();
  }

  calculaDimensoes(growGreenCalculatorData) {
    this.modulosDeAltura = Math.floor(this.alturaParede / this.alturaModulo);
    this.modulosDeLargura = Math.floor(this.larguraParede / this.larguraModulo);

    this.totalModulosInteiros = this.modulosDeAltura * this.modulosDeLargura;

    this.alturaJardimVertical = this.modulosDeAltura * this.alturaModulo + 0.02;
    this.larguraJardimVertical =
      this.modulosDeLargura * this.larguraModulo + 0.017;

    // Nicho e Duplo
    const espacoDisponivel = this.larguraParede - this.larguraJardimVertical;

    console.log(`Espaço disponível ${espacoDisponivel}`);

    if (
      espacoDisponivel >= this.larguraNicho &&
      espacoDisponivel < this.larguraDuplo
    ) {
      this.larguraJardimVertical += this.larguraNicho;
      this.totalModulosNicho = this.modulosDeAltura;
    }

    if (
      espacoDisponivel >= this.larguraDuplo &&
      espacoDisponivel < this.larguraModulo + 0.2
    ) {
      this.larguraJardimVertical += this.larguraDuplo;
      this.totalModulosDuplos = this.modulosDeAltura;
    }

    console.log(
      "Altura jardim Vertical",
      this.alturaJardimVertical,
      "largura Jv",
      this.larguraJardimVertical
    );

    this.areaJardimVertical =
      this.alturaJardimVertical * this.larguraJardimVertical;
    console.log("Area:", this.areaJardimVertical);

    this.alturaParede = growGreenCalculatorData.alturaParede;
    this.larguraParede = growGreenCalculatorData.larguraParede;
  }

  calculaQuantidades() {
    this.totalPlantas =
      this.totalModulosInteiros * 3 +
      this.totalModulosDuplos * 2 +
      this.totalModulosNicho;

    //Estrutural
    this.totalPlacaHorizontal =
      this.totalModulosInteiros * 4 +
      this.modulosDeLargura * 2 +
      this.totalModulosDuplos * 2 +
      1;

    this.totalPlacaVertical =
      this.totalModulosInteiros * 3 +
      this.modulosDeAltura +
      this.totalModulosDuplos * 2 +
      this.totalModulosNicho;

    this.totalVasosGrowGreen =
      this.totalModulosInteiros * 3 +
      this.totalModulosDuplos * 2 +
      this.totalModulosNicho;

    this.totalConchaGrowGreen = this.totalVasosGrowGreen;

    this.totalTelaGrowGreen = this.totalVasosGrowGreen;

    this.totalPinoDaConcha = this.totalVasosGrowGreen * 2;

    this.totalInicialFinal = this.modulosDeAltura * 4;

    this.totalPinoDeTravamento =
      this.totalModulosInteiros * 18 +
      this.totalModulosDuplos * 12 +
      this.totalModulosNicho * 6 +
      this.modulosDeLargura * 3 +
      this.modulosDeAltura * 6 +
      2;

    if (this.totalModulosDuplos !== 0) {
      this.totalPlacaDuplo = Math.floor(this.totalModulosDuplos * 2 + 1);
      this.totalPlacaHorizontal += this.totalPlacaDuplo;
    }

    if (this.totalModulosNicho !== 0) {
      this.totalPlacaNicho = Math.floor(this.totalModulosNicho * 2 + 1);
    }

    //Irrigacao

    if (this.temIrrigacao) {
      this.totalTuboCego = Math.floor(
        this.modulosDeLargura * this.larguraModulo * this.modulosDeAltura +
          this.modulosDeLargura * this.alturaModulo * 2 +
          1
      );
      this.totalConectorCotovelo = 3;
      this.totalGotejador = this.totalPlantas;
      this.totalFinalDeLinha = Math.floor(this.modulosDeAltura - 1);
      this.totalConectorTe = Math.floor(this.modulosDeAltura - 2);
      this.totalConectorInicial = 1;
    }

    //Fixação

    this.totalParafusos =
      this.totalModulosInteiros * 4 +
      this.totalModulosDuplos * 3 +
      this.totalModulosNicho * 2;

    this.totalBuchas = this.totalParafusos;

    this.dadosAPI = {
      alturaParede: this.alturaParede,
      larguraParede: this.larguraParede,
      alturaJardimVertical: this.alturaJardimVertical,
      larguraJardimVertical: this.larguraJardimVertical,
      areaJardimVertical: this.areaJardimVertical,
      totalPlantas: this.totalPlantas,
      totalPlacaHorizontal: this.totalPlacaHorizontal,
      totalPlacaVertical: this.totalPlacaVertical,
      totalPlacaNicho: this.totalPlacaNicho,
      totalPlacaDuplo: this.totalPlacaDuplo,
      totalVasos: this.totalVasos,
      totalBolsasSubstrato: this.totalBolsasSubstrato,
      totalInicialFinal: this.totalInicialFinal,
      totalTuboCego: this.totalTuboCego,
      totalGotejador: this.totalGotejador,
      totalConectorTe: this.totalConectorTe,
      totalConectorCotovelo: this.totalConectorCotovelo,
      totalConectorInicial: this.totalConectorInicial,
      totalFinalDeLinha: this.totalFinalDeLinha,
      totalParafusos: this.totalParafusos,
      totalBuchas: this.totalBuchas,
    };

    return this.dadosAPI;
  }
}
